export default {
  /**
   * @property {Object} subMenu,
   * Items of the submenu.
   * @property {Array} items,
   * @property {Boolean} visible,
   * @property {Boolean} collapsed,
   */
  subMenu: {
    routeName: '',
    previousRouteName: '',
    items: [],
    collapsed: false,
    isVisible() {
      return !!(this.items || []).length;
    },
  },
  /**
   * @property {Object} subMenu,
   * Items of the engineering and sensors submenu.
   * @property {Array} items,
   */
  assetSubMenu: {
  },
};
